import React from 'react'

export type NavHeaderProps = {
    label: string
}

export const NavHeader = ({ label }: NavHeaderProps) => {
    return (
        <li className="bg-white mt-2 pt-4 pb-4 pl-12 flex items-center relative">
            <p className="text-xl font-medium text-yf-green">{label}</p>
        </li>
    )
}
